import { render, staticRenderFns } from "./EmployeeItem.vue?vue&type=template&id=5b81d9bc&scoped=true&"
import script from "./EmployeeItem.vue?vue&type=script&lang=js&"
export * from "./EmployeeItem.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeItem.vue?vue&type=style&index=0&id=5b81d9bc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b81d9bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardText,VIcon,VImg,VListItem})
